/* eslint-disable no-useless-concat */
import React, { useState, useEffect } from "react";
import Dashboard from "../../Dashboard";
import "./index.css";
import { getUser } from "../../utils/common";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import { FaFileExport } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { useMediaQuery } from "@mui/material";
import { getAllCartRequestAction } from "../../../store/cart/actions";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Select } from "antd";
import { axiosRequest } from "../../../api";
const Team_URL = "team?excludeTypes=ADMIN_A,CASHIER_C";

const SalesHistory = () => {
  const { cart } = useSelector((state) => state);
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentpage] = useState(1);
  const [postsPerPage] = useState(12);
  const [loading, setLoading] = useState(true);
  const [teamMemberData, setTeamMemberData] = useState([]);
  const [selectedTeamMember, setSelectedTeamMember] = useState(null);
  const isTablet = useMediaQuery("(max-width: 960px)");

  const user = getUser();
  const findRole = user[0]?.roles[0]?.permissions;
  const permissions = [];
  findRole?.map((item) => permissions?.push(item.permissions));

  useEffect(() => {
    getAllCartRequestAction(`?status=paid&limit=${postsPerPage}&page=${currentPage - 1}${selectedTeamMember ? `&barber=${selectedTeamMember}` : ""}`)(dispatch);
  }, [dispatch, postsPerPage, currentPage, selectedTeamMember]);

  const paginate = ({ selected }) => {
    setCurrentpage(selected + 1);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    const lowercaseValue = value.toLowerCase();
    setSearch(lowercaseValue);
  };

  useEffect(() => {
    setLoading(true);
    axiosRequest
      .get(Team_URL)
      .then((response) => {
        setLoading(false);
        const result = response.data.data;
        setTeamMemberData(result);
      })
      .catch((error) => {
        console.log(error.message);
      });

  }, [])


  return (
    <Dashboard>
      <div className={`content-body mt-[4rem] ${!isTablet && "ml-52"}`}>
        <div className="container-fluid">
          <div
            className={`relative form-head ${!isTablet && "mb-3"
              } flex items-center justify-between`}
          >
            <div
              className={`mr-auto d-lg-block ${isTablet ? "w-full" : "w-2/5"}`}
            >
              <h2
                className={`text-black font-w500 mb-6 ${isTablet && "text-lg pl"
                  }`}
              >
                Sales History
              </h2>
            </div>

            <div className="col-md-6 flex justify-end mb-4 space-x-4">
              <Select
                allowClear
                onChange={(value) => setSelectedTeamMember(value)}
                size="large"
                showSearch
                style={{ width: 300 }}
                placeholder="Filter by Barber"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={teamMemberData?.map((el) => {
                  return {
                    value: el?._id, label: `${el?.firstname} ${el?.lastname}`
                  }
                })}
                disabled={loading}
              />
              <input
                type="text"
                name="name"
                value={search}
                onChange={handleInputChange}
                className="form-input w-full  py-2 px-4 rounded-md border border-solid border-[#d1d1d1] focus:border-[#e3b04b] focus:ring focus:ring-[#e3b04b]"
                placeholder="Search by Client or date"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                {permissions?.indexOf("export-sales-history") !== -1 &&
                  !isTablet && (
                    <div className=" absolute right-6 items-center justify-center top-3 flex gap-2">
                      <small>Export</small>
                      <ReactHtmlTableToExcel
                        id="test-table-xls-button"
                        className="btn btn-sm btn-primary light flex items-center svg-btn shadow-none z-15"
                        table="table-to-xls"
                        filename="Barber-Client"
                        sheet="Sales history"
                        buttonText={<FaFileExport />}
                      />
                    </div>
                  )}
                <div className="card-body mt-5">
                  <div className="table-responsive">
                    <table id="table-to-xls" className="display w-full">
                      <thead>
                        <tr className="border-b">
                          <th className="py-6">Date</th>
                          <th className="py-6">Approved By</th>
                          <th className="py-6">Barber</th>
                          <th className="py-6">Client</th>
                          {!isTablet && <th className="py-6">Status</th>}
                          <th className="py-6">Discount</th>
                          <th className="py-6">Total</th>
                          <th className="py-6">Action</th>

                        </tr>
                      </thead>
                      <tbody>
                        {cart?.all?.data
                          ?.filter((item) => {
                            return search?.toLowerCase() === ""
                              ? item
                              : item?.client?.firstname
                                ?.toLowerCase()
                                ?.includes(search) ||
                              item?.user?.firstname
                                ?.toLowerCase()
                                ?.includes(search) ||
                              item.createdAt
                                ?.split("T")[0]
                                ?.toLowerCase()
                                ?.includes(search);
                          })
                          ?.map((item, index) => (
                            <tr key={index} className="border-b">
                              <td className="py-3">
                                {item.updatedAt?.slice(0, 16)}
                              </td>
                              <td className="py-3 capitalize">
                                {item.user && item?.user?.firstname}
                              </td>
                              <td className="py-3 capitalize">
                                {`${item?.barber?.firstname || ""} ${item?.barber?.lastname || ""}`}
                              </td>
                              <td className="py-3 capitalize">
                                <div className="flex flex-col space-y-1">
                                  <span>{item.client && item?.client?.firstname}</span>
                                  <small className="text-xs">{item.client?.hasSubscription?.toLowerCase() === "yes" ? "Membership" : ""}</small>
                                </div>
                              </td>
                              {!isTablet && (
                                <td className="py-3">
                                  <span className="badge light badge-success capitalize">
                                    {item.status}
                                  </span>
                                </td>
                              )}
                              <td className="py-3">{`${item?.discount}%`}</td>
                              <td className={`py-3`}>{`${item?.amoutPaid?.toLocaleString()} RWF`}</td>
                              <td className="py-3">
                                <Link
                                  to={`/sales/history/details/${item?._id}`}
                                >
                                  {permissions.indexOf("view-sales-history") !==
                                    -1 && (
                                      <button className="bg-gray-900 hover:bg-[#cf7500] rounded shadow btn-xs sharp mr-1 bell bell-link">
                                        <i className="fa fa-eye text-white"></i>
                                      </button>
                                    )}
                                </Link>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <ReactPaginate
                  onPageChange={paginate}
                  pageCount={Math.ceil(cart?.all?.total / postsPerPage)}
                  previousLabel={"Prev"}
                  nextLabel={"Next"}
                  containerClassName={"pagination"}
                  pageLinkClassName={"page-number"}
                  previousLinkClassName={"page-number"}
                  nextLinkClassName={"page-number"}
                  activeLinkClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dashboard>
  );
};

export default SalesHistory;
